import Quill from '../quill'
const Embed = Quill.import('blots/embed')

class Assign extends Embed {
  static create (data) {
    let node = super.create(data)
    node.setAttribute('style', 'color: #7653d6;display:inline-block')
    node.setAttribute('openid', data.openId)
    node.setAttribute('contenteditable', false)
    node.innerText = data.position ? `${data.name}-${data.position}` : `${data.name}`
    return node
  }

  // 返回节点自身的value值 用于撤销操作
  static value (node) {
    const openid = node.getAttribute('openid')
    const name = node.innerText && node.innerText.split('-')[0]
    const position = node.innerText && node.innerText.split('-')[1]
    const data = {
      openId: openid,
      position: position,
      name: name
    }
    return data
  }
}



Assign.blotName = 'selectUser'
Assign.tagName = 'span'
Assign.className = 'ks-quill-selectUser'

export default Assign



// WEBPACK FOOTER //
// ./src/public/components/kye-editor-new/blot/select-user.js